import { render, staticRenderFns } from "./teachersCurricula.vue?vue&type=template&id=21d76810&"
import script from "./teachersCurricula.vue?vue&type=script&lang=js&"
export * from "./teachersCurricula.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports